var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#53c789;}.a{opacity:0.198;}.b{fill:#fff;}.c{fill:#1f0256;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 80,
    cy: 80,
    r: 80
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.257 48.301)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2235.829,936.494,2281.92,963.1l72.956-42.121-20.734-11.97-52.222,30.15-25.534-14.742Z",
    transform: "translate(-2235.764 -909.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2235.721,976.406l46.156,26.649V981.542l-46.156-26.649Z",
    transform: "translate(-2235.721 -927.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2312.886,992.659l72.955-42.121V929.026l-72.955,42.121Z",
    transform: "translate(-2266.73 -917.056)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cb9c8a47030aad6fbfe2b7da82196d64.svg";
export { ForwardRef as ReactComponent };